RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const TitleView = RivalIQ.views.LayoutView.mixin({
        className: 'panel-list-item',
        template: '#socialPostsTitleWrapperTemplate',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        dashboardModelEvents: {
            'change:timezone': 'updateTitle'
        },
        ui: {
            title: 'h4'
        },
        regions: {
            body: '.x-body'
        },

        onBeforeRenderLoaded: function () {
            const me = this;
            me.body.showWidget(me.dashboardModel);
        },

        serializeData: function () {
            const me = this;
            return {
                title: me.getTitle()
            };
        },

        getTitle: function () {
            const me = this;

            const metric = me.dashboardModel.metrics.first();
            const timezone = RivalIQ.utils.timezone.getTimezoneAbbreviation(metric.get('timezone'), metric.get('endDate'));
            const title = me.getProp('title');

            return `${title} (${timezone})`;
        },

        updateTitle: function () {
            const me = this;
            me.ui.title.text(me.getTitle());
        }
    });

    const TimeUsageSection = Dashboard.views.CurationWidgets.mixin({
        mixins: {
            PostTagsReload: App.mixins.PostTagsReload,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        template: '#socialPostsTimeUsageTemplate',

        className: 'panel-body time-usage',
        collectionView: Dashboard.views.ColumnWidgets.extend({
            columnWidth: 6,
            pdfView: undefined,
            pngView: undefined,
            pptView: undefined,
            wrapperView: TitleView
        }),

        onRender: function () {
            const me = this;

            if (!me._isShown || !me.dashboardModel.isExporting()) {
                me.showWidgets();
            }
        },

        serializeData: function () {
            const me = this;

            const companyId = me.getProp('focusCompanyId');
            const showLegend = !me.getProp('hideLegend');
            const numCompanies = RivalIQ.state.landscape.get('companies').length;

            const isFocusCompanyOnly = RivalIQ.state.utils.isOnlyCompanySet(me.getProp('companySetDescriptor'));

            return {
                companyName: RivalIQ.state.landscape.getCompanyById(companyId).get('name'),
                showLegend: showLegend,
                isFocusCompanyOnly: isFocusCompanyOnly,
                numCompanies
            };
        }
    });

    function appendFocusCompany(baseStr) {
        return () => {
            const focusCompanyId = RivalIQ.state.utils.getFocusedCompanyId();
            return `${baseStr}, ${RivalIQ.state.landscape.getCompanyById(focusCompanyId).get('name')}`;
        };
    }

    const Widget = Dashboard.models.Widget;
    widgets.TimeWidget = Widget.extend({
        processProps: function (props) {
            const me = this;

            if (!me.metric) {
                me.metric = new RivalIQ.models.MetricDefinition({
                    concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS.id
                });
            }

            App.utils.updateMetric(me.metric, props);

            return props;
        },
        title: 'Post Times',
        getExportTitle: App.utils.exportTitle,
        getExportSubtitle: App.utils.exportSubtitle,
        getPptSubtitle: App.utils.pptSubtitle,
        propsToSerializeForExport: App.utils.widgetExportProps,
        getSlideElements: App.utils.getSlideElements,
        description: RivalIQ.strings.social_posts_time_usage_info,
        view: TimeUsageSection,
        pdfView: App.views.PdfPanel,
        pngView: App.views.PngPanel,
        viewMore: false,
        getSlides: function () {
            const me = this;

            return [
                me.buildSlide({
                    instanceIds: ['eng-rate-hourly', 'eng-rate-daily']
                }),
                me.buildSlide({
                    instanceIds: ['count-hourly', 'count-daily']
                })
            ];
        },

        widgetDefinitions: function () {
            const me = this;
            const props = me.getProps();

            const metric = me.metric;
            const companyId = props.focusCompanyId;
            const companyName = RivalIQ.state.landscape.getCompanyById(companyId).get('name');
            const audienceName = props.channel === 'facebook' ? 'Page Fan' : 'Follower';

            let widgets = [
                {
                    instanceId: 'count-hourly',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LINE_CHART,
                    metrics: new RivalIQ.collections.MetricDefinitions([
                        metric.build({
                            property: 'avg_activity_per_period',
                            dimensions: ['hour'],
                            additionalAttributes: {
                                'stroke-dasharray': '2px',
                                'stroke-dashoffset': '0px'
                            },
                            title: 'Landscape Activity',
                            name: `Avg. Daily Posts, Landscape`,
                            className: 'landscape-time-usage'
                        }),
                        metric.build({
                            property: 'avg_activity_per_period',
                            dimensions: ['companyId', 'hour'],
                            companyId: companyId,
                            title: `${companyName} Activity`,
                            name: appendFocusCompany('Avg. Daily Posts'),
                            className: 'your-time-usage'
                        })
                    ]),
                    props: {
                        ticks: 6,
                        title: 'Average Activity per Published Hour'
                    }
                },
                {
                    instanceId: 'count-daily',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LINE_CHART,
                    metrics: new RivalIQ.collections.MetricDefinitions([
                        metric.build({
                            property: 'avg_activity_per_period',
                            dimensions: ['dayOfWeek'],
                            additionalAttributes: {
                                'stroke-dasharray': '2px',
                                'stroke-dashoffset': '0px'
                            },
                            title: 'Landscape Activity',
                            name: `Avg. Daily Posts, Landscape`,
                            className: 'landscape-time-usage'
                        }),
                        metric.build({
                            property: 'avg_activity_per_period',
                            dimensions: ['companyId', 'dayOfWeek'],
                            companyId: companyId,
                            title: `${companyName} Activity`,
                            name: appendFocusCompany('Avg. Daily Posts'),
                            className: 'your-time-usage'
                        })
                    ]),
                    props: {
                        title: 'Average Activity per Published Day',
                        ticks: 7
                    }
                },
                {
                    instanceId: 'eng-rate-hourly',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LINE_CHART,
                    metrics: new RivalIQ.collections.MetricDefinitions([
                        metric.build({
                            property: 'avg_engagement_rate_per_post_in_period',
                            dimensions: ['hour'],
                            additionalAttributes: {
                                'stroke-dasharray': '2px',
                                'stroke-dashoffset': '0px'
                            },
                            title: `Landscape Engagement Rate by ${audienceName}`,
                            name: `Eng. Rate by ${audienceName}, Landscape`,
                            className: 'landscape-time-usage',
                            axisFormat: function (value) {
                                return RivalIQ.formatter.absolutePercent(value, {
                                    decimals: 2
                                });
                            }
                        }),
                        metric.build({
                            property: 'avg_engagement_rate_per_post_in_period',
                            dimensions: ['companyId', 'hour'],
                            companyId: companyId,
                            title: `${companyName} Engagement Rate by ${audienceName}`,
                            name: appendFocusCompany(`Eng. Rate by ${audienceName}`),
                            className: 'your-time-usage'
                        })
                    ]),
                    props: {
                        ticks: 6,
                        title: 'Average Engagement Rate per Published Hour'
                    }
                },
                {
                    instanceId: 'eng-rate-daily',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_LINE_CHART,
                    metrics: new RivalIQ.collections.MetricDefinitions([
                        metric.build({
                            property: 'avg_engagement_rate_per_post_in_period',
                            dimensions: ['dayOfWeek'],
                            additionalAttributes: {
                                'stroke-dasharray': '2px',
                                'stroke-dashoffset': '0px'
                            },
                            title: `Landscape Engagement Rate by ${audienceName}`,
                            name: `Eng. Rate by ${audienceName}, Landscape`,
                            className: 'landscape-time-usage',
                            axisFormat: function (value) {
                                return RivalIQ.formatter.absolutePercent(value, {
                                    decimals: 2
                                });
                            }
                        }),
                        metric.build({
                            property: 'avg_engagement_rate_per_post_in_period',
                            dimensions: ['companyId', 'dayOfWeek'],
                            companyId: companyId,
                            title: `${companyName} Engagement Rate by ${audienceName}`,
                            name: appendFocusCompany(`Eng. Rate by ${audienceName}`),
                            className: 'your-time-usage'
                        })
                    ]),
                    props: {
                        ticks: 7,
                        title: 'Average Engagement Rate per Published Day'
                    }
                }
            ];

            if (me.getProp('instanceIds')) {
                widgets = _.filter(widgets, function (def) {
                    return _.includes(me.getProp('instanceIds'), def.instanceId);
                });
            }

            return widgets;
        },
        filter: function () {
            const me = this;
            return !RivalIQ.props.channelAccess(me.getProps());
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_TIME_USAGE, widgets.TimeWidget);
}, window.moment);
